import naja from "naja";
/**
 * Zajistí, že odkazy paginace budou volány ajaxem i přes to, že nejsou označeny požadovaným selectorem.
 * Wrapper odkazů paginace musí nést třídu ajax
 */

export default class AjaxifyPaginationExtension {

    initialize(naja) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.do()
                naja.addEventListener('complete', this.do)
            });
        } else {
            this.do();
            naja.addEventListener('complete', this.do)
        }
        
    }

    do() {
        // při kliknutí na a.page-link zjistí, zda má jeho wrapper třídu .ajax
        // a popř. vykoná ajaxový request
        [...document.querySelectorAll('a.page-link')].forEach((link) => {
            link.addEventListener('click', e => {
                if (link.closest('.ajax')) {
                    e.preventDefault();
                    naja.uiHandler.clickElement(link);
                }
            });
        });

    }



}